module.exports=function(scope){ return `<div class="global-menu-item ${scope.disabledClass}">
    <div class="${scope.classNames}">
        <a href="${scope.url}" target="${scope.opensInNewTab ? '_blank' : '_self'}" rel="noopener noreferrer">
            <div class="global-menu-item__icon">
                ${scope.icon}
            </div>
            <div class="global-menu-item__details">
                <span class="global-menu-item__title">${scope.title}</span>
                <p class="global-menu-item__description">${scope.description}</p>
            </div>
        </a>
        <div class="global-menu-item__legacy ${scope.legacyName === null ? 'hidden' : ''}">
            <a href="${scope.legacyUrl}" target="${scope.opensInNewTab ? '_blank' : '_self'}" rel="noopener noreferrer">
                ${scope.legacyName}
            </a>
        </div>
    </div>
</div>`};


// WEBPACK FOOTER //
// ./src/templates/global-menu-item.tpl.html